import evalCondition from 'Helpers/evalCondition'

/**
 * Evaluate one or man conditions and returns values in array
 * @param {string | array} conditions conditions to evaluate
 */
export const useConditions = conditions =>
  [].concat(conditions).map(condition => evalCondition(condition))
